<header-title [model]="headerTitle"></header-title>
<section role="main" class="content-body tab-menu-opened">
    <div class="row">
        <div class="col">
            <section class="card">
                <header class="card-header">
                    <h3 class="text-gray-600 m-0">Create New Question Bank</h3>
                </header>
                <div class="card-body py-5">
                    <form (submit)="addModule()" [formGroup]="addQuestionBankFormGroup">
                        <fieldset>
                            <div class="panel-body">
                                <error-message [errors]="errors"></error-message>
                                <div class="row mt-3">
                                    <div class="col-md-3">
                                        <label class="control-label">Name</label>
                                        <input type="text" class="form-control" formControlName="name" />
                                    </div>
                                    <div class="col-md-3">
                                        <label class="control-label">Nr Of Optional Questions</label>
                                        <input type="text" class="form-control" formControlName="nrOptionalQuestions" />
                                    </div>
                                </div>
                            </div>
                            <footer class="panel-footer mt-3">
                                <div class="row">
                                    <div class="col text-end">
                                        <button class="btn btn-outline-primary" type="button" (click)="onBack()">Back</button>
                                        <button class="btn btn-success ms-2" type="submit">Create</button>
                                    </div>
                                </div>
                            </footer>
                        </fieldset>
                    </form>
                </div>
            </section>
        </div>
    </div>
</section>
